module.exports = __webpack_public_path__ + "img/module1_icon1.0b256bbd.png";